import { clientPortalRequest, buildClientQuery } from "./clientPortalFetch";

const base = (clientViewId) => `/views/${clientViewId}/servicios`;

export function getVendorDirectoryAuth(clientViewId) {
  return clientPortalRequest(`${base(clientViewId)}/auth/me`);
}

export function getVendorDirectoryTaxonomy(clientViewId, { locale } = {}) {
  const query = locale ? buildClientQuery({ locale }) : "";
  return clientPortalRequest(`${base(clientViewId)}/taxonomia${query}`);
}

export function listVendorDirectoryVendors(clientViewId, params = {}) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores${buildClientQuery(params)}`);
}

export function checkVendorDirectoryDuplicates(clientViewId, body) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores/duplicados`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function createVendorDirectoryVendor(clientViewId, body) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function getVendorDirectoryVendor(clientViewId, vendorId) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores/${vendorId}`);
}

export function updateVendorDirectoryVendor(clientViewId, vendorId, body) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores/${vendorId}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}

export function getVendorDirectoryReadiness(clientViewId, vendorId) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores/${vendorId}/preparacion`);
}

export function publishVendorDirectoryVendor(clientViewId, vendorId, body = {}) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores/${vendorId}/publicar`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function unpublishVendorDirectoryVendor(clientViewId, vendorId, body = {}) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores/${vendorId}/despublicar`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function suspendVendorDirectoryVendor(clientViewId, vendorId, body) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores/${vendorId}/suspender`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function reactivateVendorDirectoryVendor(clientViewId, vendorId, body = {}) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores/${vendorId}/reactivar`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function archiveVendorDirectoryVendor(clientViewId, vendorId, body = {}) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores/${vendorId}/archivar`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function restoreVendorDirectoryVendor(clientViewId, vendorId, body = {}) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores/${vendorId}/restaurar`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function upsertVendorDirectoryContact(clientViewId, vendorId, body) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores/${vendorId}/contactos`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function replaceVendorDirectoryHours(clientViewId, vendorId, periods) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores/${vendorId}/horarios`, {
    method: "PUT",
    body: JSON.stringify({ periods }),
  });
}

export function replaceVendorDirectoryLanguages(clientViewId, vendorId, languages) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores/${vendorId}/idiomas`, {
    method: "PUT",
    body: JSON.stringify({ languages }),
  });
}

export function replaceVendorDirectoryPaymentMethods(clientViewId, vendorId, paymentMethods) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores/${vendorId}/pagos`, {
    method: "PUT",
    body: JSON.stringify({ paymentMethods }),
  });
}

export function upsertVendorDirectoryLocation(clientViewId, vendorId, body) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores/${vendorId}/ubicaciones`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function upsertVendorDirectoryServiceArea(clientViewId, vendorId, body) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores/${vendorId}/areas`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function addVendorDirectoryCategory(clientViewId, vendorId, body) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores/${vendorId}/categorias`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function addVendorDirectoryNote(clientViewId, vendorId, body) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores/${vendorId}/notas`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function listVendorDirectoryNotes(clientViewId, vendorId, params = {}) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores/${vendorId}/notas${buildClientQuery(params)}`);
}

export function listVendorDirectoryAudit(clientViewId, vendorId, params = {}) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores/${vendorId}/auditoria${buildClientQuery(params)}`);
}

export function assignVendorDirectory(clientViewId, vendorId, body) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores/${vendorId}/asignacion`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}
